import { Skeleton } from '@worldcoo/ui/components/skeleton';
import { cn } from '@worldcoo/ui/lib/utils';
import { Header } from './header';
import { HeroPending } from './hero';
import { CampaignsGridPending } from './campaigns';
import { CampaignHeroPending } from './campaign-hero';
import {
	BACK_LINK_ROW_CLASS,
	CampaignBackNav,
	CampaignBottomSection,
	CampaignColumns,
	CampaignLayout,
	CampaignTopSection,
	HeroSection,
	HomeLayout,
	HomeMain,
	CampaignsSection,
	LegalLayout,
	LEGAL_CONTENT_CLASS,
} from './page-shell';

/**
 * The REAL `<Header />`, not a skeleton: behind its own boundary it paints at once on a client navigation.
 * Geometry from page-shell.tsx; a section owning a skeleton exports it instead of being redrawn here.
 */

export function HomePending() {
	return (
		<HomeLayout>
			<HomeMain>
				<Header />
				<HeroSection>
					<HeroPending />
				</HeroSection>

				<CampaignsSection>
					<CampaignsGridPending />
				</CampaignsSection>
			</HomeMain>
		</HomeLayout>
	);
}

export function CampaignPending() {
	return (
		<CampaignLayout>
			<Header />
			<CampaignTopSection>
				<CampaignBackNav>
					<div className={BACK_LINK_ROW_CLASS}>
						<Skeleton className="h-6 w-40" />
					</div>
				</CampaignBackNav>

				<HeroSection>
					<CampaignHeroPending />
				</HeroSection>
			</CampaignTopSection>

			<CampaignBottomSection>
				<CampaignColumns>
					<div className="flex w-full flex-col gap-4 lg:w-2/3">
						<Skeleton className="h-8 w-56" />
						<Skeleton className="h-4 w-full" />
						<Skeleton className="h-4 w-full" />
						<Skeleton className="h-4 w-4/5" />
						<Skeleton className="h-64 w-full rounded-xl" />
					</div>
					<aside className="w-full flex-1">
						<Skeleton className="h-80 w-full rounded-xl" />
					</aside>
				</CampaignColumns>
			</CampaignBottomSection>
		</CampaignLayout>
	);
}

export function LegalPagePending() {
	return (
		<LegalLayout>
			<Header />
			<div className={cn(LEGAL_CONTENT_CLASS, 'flex flex-col gap-3')}>
				<Skeleton className="mb-4 h-8 w-64" />
				{Array.from({ length: 10 }).map((_, index) => (
					// oxlint-disable-next-line react/no-array-index-key
					<Skeleton key={index} className={index % 4 === 3 ? 'h-4 w-2/3' : 'h-4 w-full'} />
				))}
			</div>
		</LegalLayout>
	);
}
